import { axios } from "@/utils"

export default {
    getCart(params) {
        return axios.get('/v1/cart/', { params: params })
    },

    deleteCart() {
        return axios.delete('/v1/cart/')
    },

    createCartDigitalItemPhotolist(picacode, photoIds) {
        return axios.post('/v1/cart-digital-items/', {
            order_type: "photolist",
            picacode,
            photo_ids: photoIds
        })
    },

    addPhotoToCartDigitalItem(digitalItemId, photoIds) {
        return axios.patch(`/v1/cart-digital-items/${digitalItemId}/add-photos/`, { photo_ids: photoIds })
    },

    createCartDigitalItemAsPackage(picacode, orderType='photopackage') {
        return axios.post('/v1/cart-digital-items/', {
            order_type: orderType,
            picacode
        })
    },

    updateCartDigitalItemAsPackage(digitalItemId, orderType='photopackage') {
        return axios.patch(`/v1/cart-digital-items/${digitalItemId}/set-type/`, { order_type: orderType })
    },

    deletePhotosFromDigitalItem(digitalItemId, photoIds) {
        return axios.patch(`/v1/cart-digital-items/${digitalItemId}/delete-photos/`, { photo_ids: photoIds })
    },

    deleteVideosFromDigitalItem(digitalItemId) {
        return axios.patch(`/v1/cart-digital-items/${digitalItemId}/delete-videos/`)
    },

    deleteCartDigitalItem(digitalItemId) {
        return axios.delete(`/v1/cart-digital-items/${digitalItemId}/`)
    },

    createCartPrintItem(body) {
        return axios.post('/v1/cart-print-items/', body)
    },

    updateCartPrintItem(printItemId, body) {
        console.warn(printItemId, body)
        return axios.patch(`/v1/cart-print-items/${printItemId}/`, body)
    },

    deleteCartPrintItem(printItemId) {
        return axios.delete(`/v1/cart-print-items/${printItemId}/`)
    },

    // eslint-disable-next-line
    updatePrintOrder(orderGuid, shippingAddressFields) {
        return axios.patch(`/v1/cart-shipping-address/${orderGuid}/`, shippingAddressFields)
        // return axios.patch(`/api/v1/print-orders/${orderGuid}/`, shippingAddressFields)
    },

    placeOrder(paymentMethod, paymentMethodId, billingAddress, campaignCode, invoice) {
        let body = {
            platform: 'site'
        }
        if (paymentMethodId !== null)
            body['payment_method_id'] = paymentMethodId
        if (paymentMethod !== null)
            body['payment_method'] = paymentMethod
        if (billingAddress !== null)
            body['billing_address'] = billingAddress
        if(campaignCode)
            body['campaign_code'] = campaignCode
        if(invoice)
            body['invoice'] = invoice
        return axios.post('/v3/orders/', body)
    },

    confirmPayment(transactionId, paymentMethod, extraData) {
        return axios.post(`/v3/orders/confirm-payment/`,  {
            transaction_id: transactionId,
            payment_method: paymentMethod,
            extra_data: extraData
        })
    },

    getOrders(params) {
        let url = `/v3/orders/`
        if (params.hasOwnProperty('orderId'))
            url += `${params.orderId}/`
        return axios.get(url)
    },

    getCountries() {
        return axios.get(`/v1/countries/`)
    }
}
